"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRedux = require("react-redux");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _cropperjs = _interopRequireDefault(require("cropperjs"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILightbox = _interopRequireDefault(require("UIComponents/lightbox/UILightbox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIIconButton = _interopRequireDefault(require("UIComponents/button/UIIconButton"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UIInputStaticLabel = _interopRequireDefault(require("UIComponents/input/UIInputStaticLabel"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _Constants = require("FileManagerCore/Constants");

var AspectRatioRoundingModes = _interopRequireWildcard(require("FileManagerCore/constants/AspectRatioRoundingModes"));

var AspectRatios = _interopRequireWildcard(require("FileManagerCore/constants/AspectRatios"));

var _ImageEditor = require("FileManagerCore/utils/ImageEditor");

var _EditAndCreateImage = require("FileManagerCore/selectors/EditAndCreateImage");

var _stringUtils = require("FileManagerCore/utils/stringUtils");

var _getIsImageEditorSaveButtonDisabled = _interopRequireDefault(require("FileManagerCore/utils/getIsImageEditorSaveButtonDisabled"));

function getI18nKey(suffix) {
  return "FileManagerCore.imageEditor." + suffix;
}

var PRESET_ASPECT_RATIOS = (0, _keyMirror.default)({
  CUSTOM: null,
  SQUARE: null,
  TWO_ONE: null,
  FOUR_FIVE: null,
  FB_LANDSCAPE: null,
  // facebook
  IG_LANDSCAPE: null,
  // instagram
  LINKEDIN: null
});
var COMMON_ICON_PROPS = {
  size: 'xs',
  style: {
    verticalAlign: 'inherit'
  }
};
var BACK_AND_CANCEL_BUTTON_COMMON_PROPS = {
  className: 'm-right-4',
  use: 'link-on-dark'
};
var DEFAULT_ROTATION_DEGREES = 45;

var ImageEditor =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ImageEditor, _Component);

  function ImageEditor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImageEditor);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImageEditor).call(this, props));
    _this.state = {
      cropperReady: false,
      cropperMode: '',
      cropperWidth: '0',
      cropperHeight: '0',
      unsavedImgWidth: null,
      unsavedImgHeight: null,
      aspectRatio: PRESET_ASPECT_RATIOS.CUSTOM
    };
    _this.imageContainer = null;

    _this.ImageComponent = function (imageProps) {
      return _react.default.createElement(_UISection.default, {
        style: {
          width: '100%',
          height: 'calc(100% - 5rem)'
        }
      }, _react.default.createElement(_UIImage.default, (0, _extends2.default)({
        style: {
          opacity: 0.5,
          marginLeft: 'auto',
          marginRight: 'auto'
        },
        ref: _this.setImageContainer
      }, imageProps)));
    };

    _this.setImageContainer = function (element) {
      _this.imageContainer = _reactDom.default.findDOMNode(element); // eslint-disable-line react/no-find-dom-node
    };

    _this.initializeCropper = _this.initializeCropper.bind((0, _assertThisInitialized2.default)(_this));
    _this.getImageDimInputVal = _this.getImageDimInputVal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRotate = _this.onRotate.bind((0, _assertThisInitialized2.default)(_this));
    _this.adjustCropBox = _this.adjustCropBox.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetCropper = _this.resetCropper.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetCropperDimensionsAndPosition = _this.resetCropperDimensionsAndPosition.bind((0, _assertThisInitialized2.default)(_this));
    _this.onAspectRatioChange = _this.onAspectRatioChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ImageEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeCropper();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.updateRequestStatus === _Constants.RequestStatus.PENDING && this.props.updateRequestStatus === _Constants.RequestStatus.SUCCEEDED) {
        this.props.onClose();
      }
    }
  }, {
    key: "resetCropper",
    value: function resetCropper() {
      if (this.cropper) this.cropper.reset();
    }
  }, {
    key: "adjustCropBoxToSquare",
    value: function adjustCropBoxToSquare(imgWidth, imgHeight) {
      this.cropper.setCropBoxData((0, _ImageEditor.getCropBoxDataObjForSquareImage)(this.cropper.getCropBoxData(), this.cropper.getContainerData(), this.cropper.getCanvasData(), imgHeight, imgWidth));

      if (imgWidth > imgHeight) {
        this.setState({
          cropperWidth: imgHeight.toString()
        });
      } else {
        this.setState({
          cropperHeight: imgWidth.toString()
        });
      }
    }
  }, {
    key: "adjustWidthOrHeightToMakeCropBoxVertical",
    value: function adjustWidthOrHeightToMakeCropBoxVertical(_ref) {
      var imgWidth = _ref.imgWidth,
          potentialNewWidth = _ref.potentialNewWidth,
          potentialNewHeight = _ref.potentialNewHeight;

      if (potentialNewWidth < imgWidth) {
        this.adjustCropBoxWidth(potentialNewWidth);
      } else {
        this.adjustCropBoxHeight(potentialNewHeight);
      }
    }
  }, {
    key: "adjustWidthOrHeightToMakeCropBoxHorizontal",
    value: function adjustWidthOrHeightToMakeCropBoxHorizontal(_ref2) {
      var imgHeight = _ref2.imgHeight,
          potentialNewWidth = _ref2.potentialNewWidth,
          potentialNewHeight = _ref2.potentialNewHeight;

      if (potentialNewHeight < imgHeight) {
        this.adjustCropBoxHeight(potentialNewHeight);
      } else {
        this.adjustCropBoxWidth(potentialNewWidth);
      }
    }
  }, {
    key: "adjustCropBoxHeight",
    value: function adjustCropBoxHeight(newHeight) {
      var canvasData = this.cropper.getCanvasData();
      this.cropper.setCropBoxData((0, _ImageEditor.getCropBoxDataObjWithSmallerHeight)(this.cropper.getCropBoxData(), this.cropper.getContainerData(), newHeight, canvasData.height / canvasData.naturalHeight));
      this.setState({
        cropperHeight: newHeight.toString()
      });
    }
  }, {
    key: "adjustCropBoxWidth",
    value: function adjustCropBoxWidth(newWidth) {
      var canvasData = this.cropper.getCanvasData();
      this.cropper.setCropBoxData((0, _ImageEditor.getCropBoxDataObjWithSmallerWidth)(this.cropper.getCropBoxData(), this.cropper.getContainerData(), newWidth, canvasData.width / canvasData.naturalWidth));
      this.setState({
        cropperWidth: newWidth.toString()
      });
    }
  }, {
    key: "resetCropperDimensionsAndPosition",
    value: function resetCropperDimensionsAndPosition() {
      this.cropper.setCropBoxData((0, _ImageEditor.getCropBoxDataForDimensionAndPositionReset)(this.cropper.getContainerData(), this.cropper.getCanvasData()));
    }
  }, {
    key: "onAspectRatioChange",
    value: function onAspectRatioChange(_ref3) {
      var aspectRatio = _ref3.target.value;

      var _this$cropper$getCanv = this.cropper.getCanvasData(),
          _this$cropper$getCanv2 = _this$cropper$getCanv.naturalHeight,
          imgHeight = _this$cropper$getCanv2 === void 0 ? this.props.imgHeight : _this$cropper$getCanv2,
          _this$cropper$getCanv3 = _this$cropper$getCanv.naturalWidth,
          imgWidth = _this$cropper$getCanv3 === void 0 ? this.props.imgWidth : _this$cropper$getCanv3;

      this.resetCropperDimensionsAndPosition();
      this.adjustCropBox(aspectRatio, imgWidth, imgHeight);
      this.setState({
        aspectRatio: aspectRatio
      });
    }
  }, {
    key: "adjustCropBox",
    value: function adjustCropBox(aspectRatio, imgWidth, imgHeight) {
      switch (aspectRatio) {
        case PRESET_ASPECT_RATIOS.CUSTOM:
          break;

        case PRESET_ASPECT_RATIOS.SQUARE:
          this.adjustCropBoxToSquare(imgWidth, imgHeight);
          break;

        case PRESET_ASPECT_RATIOS.TWO_ONE:
          this.adjustWidthOrHeightToMakeCropBoxHorizontal(_ImageEditor.getRectangularAdjustCropBoxParams.apply(void 0, [imgWidth, imgHeight].concat((0, _toConsumableArray2.default)(AspectRatios.TWO_ONE))));
          break;

        case PRESET_ASPECT_RATIOS.FOUR_FIVE:
          this.adjustWidthOrHeightToMakeCropBoxVertical(_ImageEditor.getRectangularAdjustCropBoxParams.apply(void 0, [imgWidth, imgHeight].concat((0, _toConsumableArray2.default)(AspectRatios.FOUR_FIVE), [AspectRatioRoundingModes.ABOVE])));
          break;

        case PRESET_ASPECT_RATIOS.FB_LANDSCAPE:
          this.adjustWidthOrHeightToMakeCropBoxHorizontal(_ImageEditor.getRectangularAdjustCropBoxParams.apply(void 0, [imgWidth, imgHeight].concat((0, _toConsumableArray2.default)(AspectRatios.FB_LANDSCAPE))));
          break;

        case PRESET_ASPECT_RATIOS.IG_LANDSCAPE:
          this.adjustWidthOrHeightToMakeCropBoxHorizontal(_ImageEditor.getRectangularAdjustCropBoxParams.apply(void 0, [imgWidth, imgHeight].concat((0, _toConsumableArray2.default)(AspectRatios.IG_LANDSCAPE), [AspectRatioRoundingModes.BELOW])));
          break;

        case PRESET_ASPECT_RATIOS.LINKEDIN:
          this.adjustWidthOrHeightToMakeCropBoxHorizontal(_ImageEditor.getRectangularAdjustCropBoxParams.apply(void 0, [imgWidth, imgHeight].concat((0, _toConsumableArray2.default)(AspectRatios.LINKEDIN))));
          break;

        default:
          break;
      }
    }
  }, {
    key: "getAspectRatioOpts",
    value: function getAspectRatioOpts() {
      return [{
        text: _I18n.default.text(getI18nKey("aspectRatios." + PRESET_ASPECT_RATIOS.CUSTOM)),
        value: PRESET_ASPECT_RATIOS.CUSTOM,
        avatar: _react.default.createElement("div", {
          style: {
            border: '3px solid #cbd6e2',
            borderRadius: '5px'
          }
        })
      }, {
        text: _I18n.default.text(getI18nKey("aspectRatios." + PRESET_ASPECT_RATIOS.FB_LANDSCAPE)),
        value: PRESET_ASPECT_RATIOS.FB_LANDSCAPE,
        avatar: _react.default.createElement("div", {
          style: {
            top: 0
          }
        }, _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
          name: "socialBlockFacebook"
        }, COMMON_ICON_PROPS)))
      }, {
        text: _I18n.default.text(getI18nKey("aspectRatios." + PRESET_ASPECT_RATIOS.SQUARE)),
        value: PRESET_ASPECT_RATIOS.SQUARE,
        avatar: _react.default.createElement("div", {
          style: {
            top: 0
          }
        }, _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
          name: "socialBlockInstagram"
        }, COMMON_ICON_PROPS)))
      }, {
        text: _I18n.default.text(getI18nKey("aspectRatios." + PRESET_ASPECT_RATIOS.FOUR_FIVE)),
        value: PRESET_ASPECT_RATIOS.FOUR_FIVE,
        avatar: _react.default.createElement("div", {
          style: {
            top: 0
          }
        }, _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
          name: "socialBlockInstagram"
        }, COMMON_ICON_PROPS)))
      }, {
        text: _I18n.default.text(getI18nKey("aspectRatios." + PRESET_ASPECT_RATIOS.IG_LANDSCAPE)),
        value: PRESET_ASPECT_RATIOS.IG_LANDSCAPE,
        avatar: _react.default.createElement("div", {
          style: {
            top: 0
          }
        }, _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
          name: "socialBlockInstagram"
        }, COMMON_ICON_PROPS)))
      }, {
        text: _I18n.default.text(getI18nKey("aspectRatios." + PRESET_ASPECT_RATIOS.LINKEDIN)),
        value: PRESET_ASPECT_RATIOS.LINKEDIN,
        avatar: _react.default.createElement("div", {
          style: {
            top: 0
          }
        }, _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
          name: "socialBlockLinkedin"
        }, COMMON_ICON_PROPS)))
      }, {
        text: _I18n.default.text(getI18nKey("aspectRatios." + PRESET_ASPECT_RATIOS.TWO_ONE)),
        value: PRESET_ASPECT_RATIOS.TWO_ONE,
        avatar: _react.default.createElement("div", {
          style: {
            top: 0
          }
        }, _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
          name: "socialBlockTwitter"
        }, COMMON_ICON_PROPS)))
      }];
    }
  }, {
    key: "getImageDimInputVal",
    value: function getImageDimInputVal(unsavedDim, savedDim) {
      if (unsavedDim === null) {
        return Math.round(savedDim).toString();
      }

      if (isNaN(unsavedDim)) {
        return '';
      }

      return Math.round(unsavedDim).toString();
    }
  }, {
    key: "initializeCropper",
    value: function initializeCropper() {
      var _this2 = this;

      this.cropper = new _cropperjs.default(this.imageContainer, {
        autoCrop: false,
        autoCropArea: 1,
        responsive: false,
        guides: false,
        center: false,
        zoomOnWheel: false,
        viewMode: 2,
        crop: function crop(evt) {
          _this2.setState({
            cropperWidth: Math.round(evt.detail.width).toString(),
            cropperHeight: Math.round(evt.detail.height).toString()
          });
        },
        cropstart: function cropstart() {
          var newState = {
            aspectRatio: PRESET_ASPECT_RATIOS.CUSTOM
          };

          if (_this2.state.cropperMode !== 'crop') {
            newState.cropperMode = 'crop';
          }

          _this2.setState(newState);
        },
        ready: function ready() {
          _this2.setState({
            cropperReady: true
          });
        }
      });
    }
  }, {
    key: "onRotate",
    value: function onRotate() {
      this.cropper.rotate(DEFAULT_ROTATION_DEGREES);

      var _getNewCanvasAndBoxDa = (0, _ImageEditor.getNewCanvasAndBoxDataAfterRotation)(this.cropper.getContainerData(), this.cropper.getCropBoxData(), this.cropper.getCanvasData()),
          canvasData = _getNewCanvasAndBoxDa.canvasData,
          cropBoxData = _getNewCanvasAndBoxDa.cropBoxData;

      this.cropper.setCanvasData(canvasData);
      this.cropper.setCropBoxData(cropBoxData);
      this.setState({
        aspectRatio: PRESET_ASPECT_RATIOS.CUSTOM
      });
    }
  }, {
    key: "renderResizeInputs",
    value: function renderResizeInputs() {
      var _this3 = this;

      var _this$props = this.props,
          imgWidth = _this$props.imgWidth,
          imgHeight = _this$props.imgHeight,
          imgAspectRatio = _this$props.imgAspectRatio;
      var _this$state = this.state,
          unsavedImgWidth = _this$state.unsavedImgWidth,
          unsavedImgHeight = _this$state.unsavedImgHeight;
      return _react.default.createElement("div", {
        className: "align-center"
      }, _react.default.createElement("div", {
        className: "text-left"
      }, _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('sizeLabel')
      }), _react.default.createElement("span", {
        className: "display-inline-block m-left-1"
      }, "("), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('widthLabel')
      }), _react.default.createElement("span", {
        className: "display-inline-block m-x-1"
      }, "x"), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('heightLabel')
      }), _react.default.createElement("span", null, ")")), _react.default.createElement("div", {
        className: "text-right"
      }, _react.default.createElement(_UIButton.default, {
        className: "m-left-2",
        size: "xs",
        use: "unstyled",
        onClick: function onClick() {
          _this3.setState({
            unsavedImgWidth: null,
            unsavedImgHeight: null
          });
        }
      }, _react.default.createElement(_Small.default, {
        className: "reset-button"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('resetButton')
      }))))), _react.default.createElement("div", {
        className: "m-left-4",
        style: {
          maxWidth: 100
        }
      }, _react.default.createElement(_UIInputStaticLabel.default, {
        text: "px",
        position: "end"
      }, _react.default.createElement(_UINumberInput.default, {
        min: 0,
        formatter: _stringUtils.dimensionValueToString,
        "data-test-selector": "width-resize-input",
        onChange: function onChange(evt) {
          var newWidth = parseInt(evt.target.value, 10);

          _this3.setState({
            unsavedImgWidth: newWidth,
            unsavedImgHeight: Math.round(newWidth / imgAspectRatio)
          });
        },
        value: parseInt(this.getImageDimInputVal(unsavedImgWidth, imgWidth), 10),
        error: parseInt(this.getImageDimInputVal(unsavedImgWidth, imgWidth), 10) <= 0
      }))), _react.default.createElement("div", {
        className: "m-left-2"
      }, _react.default.createElement(_UIIcon.default, {
        name: "link",
        size: "xs"
      })), _react.default.createElement("div", {
        className: "m-left-2",
        style: {
          maxWidth: 100
        }
      }, _react.default.createElement(_UIInputStaticLabel.default, {
        text: "px",
        position: "end"
      }, _react.default.createElement(_UINumberInput.default, {
        min: 0,
        formatter: _stringUtils.dimensionValueToString,
        "data-test-selector": "height-resize-input",
        onChange: function onChange(evt) {
          var newHeight = parseInt(evt.target.value, 10);

          _this3.setState({
            unsavedImgWidth: Math.round(newHeight * imgAspectRatio),
            unsavedImgHeight: newHeight
          });
        },
        value: parseInt(this.getImageDimInputVal(unsavedImgHeight, imgHeight), 10),
        error: parseInt(this.getImageDimInputVal(unsavedImgHeight, imgHeight), 10) <= 0
      }))));
    }
  }, {
    key: "renderCropAndRotateControls",
    value: function renderCropAndRotateControls() {
      var _this4 = this;

      var _this$state2 = this.state,
          cropperWidth = _this$state2.cropperWidth,
          cropperHeight = _this$state2.cropperHeight,
          aspectRatio = _this$state2.aspectRatio;
      return _react.default.createElement("div", {
        className: "align-center"
      }, _react.default.createElement("div", {
        className: "m-right-4"
      }, _react.default.createElement(_UISelect.default, {
        "data-test-selector": "preset-aspect-ratios-selector",
        value: aspectRatio,
        menuWidth: "auto",
        onChange: this.onAspectRatioChange,
        options: this.getAspectRatioOpts()
      })), _react.default.createElement("div", {
        className: "crop-size-label"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('cropSizeLabel')
      }), _react.default.createElement("span", {
        className: "display-inline-block m-left-1"
      }, "("), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('widthLabel')
      }), _react.default.createElement("span", {
        className: "display-inline-block m-x-1"
      }, "x"), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('heightLabel')
      }), _react.default.createElement("span", null, ")")), _react.default.createElement("div", {
        className: "m-left-4",
        style: {
          maxWidth: 100
        }
      }, _react.default.createElement(_UIInputStaticLabel.default, {
        text: "px",
        position: "end"
      }, _react.default.createElement(_UINumberInput.default, {
        formatter: _stringUtils.dimensionValueToString,
        min: 0,
        max: this.cropper.imageData.naturalWidth,
        onChange: function onChange(evt) {
          var newWidth = parseInt(evt.target.value, 10);

          if (isNaN(newWidth)) {
            newWidth = '';
          }

          var originalImageToScreenFitScaleX = _this4.cropper.imageData.naturalWidth / _this4.cropper.imageData.width;

          _this4.cropper.setCropBoxData(Object.assign(_this4.cropper.getCropBoxData(), {
            width: newWidth / originalImageToScreenFitScaleX
          }));

          _this4.setState({
            cropperWidth: newWidth.toString()
          });
        },
        value: parseInt(cropperWidth, 10),
        error: parseInt(cropperWidth, 10) <= 0
      }))), _react.default.createElement("div", {
        className: "m-left-4",
        style: {
          maxWidth: 100
        }
      }, _react.default.createElement(_UIInputStaticLabel.default, {
        text: "px",
        position: "end"
      }, _react.default.createElement(_UINumberInput.default, {
        formatter: _stringUtils.dimensionValueToString,
        min: 0,
        max: this.cropper.imageData.naturalHeight,
        onChange: function onChange(evt) {
          var newHeight = parseInt(evt.target.value, 10);

          if (isNaN(newHeight)) {
            newHeight = '';
          }

          var originalImageToScreenFitScaleY = _this4.cropper.imageData.naturalHeight / _this4.cropper.imageData.height;

          _this4.cropper.setCropBoxData(Object.assign(_this4.cropper.getCropBoxData(), {
            height: newHeight / originalImageToScreenFitScaleY
          }));

          _this4.setState({
            cropperHeight: newHeight.toString()
          });
        },
        value: parseInt(cropperHeight, 10),
        error: parseInt(cropperHeight, 10) <= 0
      }))), _react.default.createElement(_UIIconButton.default, {
        className: "m-left-4",
        onClick: this.onRotate
      }, _react.default.createElement(_UIIcon.default, {
        name: "rotate"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          imgSrc = _this$props2.imgSrc,
          fileId = _this$props2.fileId,
          fileFolderId = _this$props2.fileFolderId,
          fileName = _this$props2.fileName,
          onClose = _this$props2.onClose,
          onCropSave = _this$props2.onCropSave,
          onResizeSave = _this$props2.onResizeSave,
          updateRequestStatus = _this$props2.updateRequestStatus,
          encoding = _this$props2.encoding;
      var _this$state3 = this.state,
          cropperReady = _this$state3.cropperReady,
          cropperMode = _this$state3.cropperMode,
          unsavedImgWidth = _this$state3.unsavedImgWidth,
          cropperWidth = _this$state3.cropperWidth,
          cropperHeight = _this$state3.cropperHeight;
      return _react.default.createElement(_UILightbox.default, {
        className: "image-editor-modal",
        onClose: onClose,
        onCloseComplete: function onCloseComplete() {
          if (_this5.cropper) {
            _this5.cropper.destroy();
          }
        },
        imageSrc: imgSrc,
        ImageComponent: this.ImageComponent
      }, !cropperMode && _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        "data-test-selector": "crop-mode-button",
        disabled: !cropperReady,
        onClick: function onClick() {
          _this5.cropper.crop();

          _this5.setState({
            cropperMode: 'crop'
          });
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('cropButton')
      })), _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        "data-test-selector": "resize-mode-button",
        onClick: function onClick() {
          _this5.setState({
            cropperMode: 'resize'
          });
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('resizeButton')
      })), _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        disabled: !cropperReady,
        onClick: this.resetCropper
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('resetButton')
      }))), _react.default.createElement("div", {
        className: "justify-left"
      }, cropperMode === 'resize' && this.renderResizeInputs(), cropperMode === 'crop' && this.renderCropAndRotateControls()), _react.default.createElement("div", null, !cropperMode && _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, BACK_AND_CANCEL_BUTTON_COMMON_PROPS, {
        onClick: function onClick() {
          return _this5.props.onClose();
        }
      }), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('cancelButton')
      })), cropperMode && _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, BACK_AND_CANCEL_BUTTON_COMMON_PROPS, {
        "data-test-selector": "back-button",
        onClick: function onClick() {
          _this5.cropper.clear();

          _this5.setState({
            cropperMode: ''
          });
        }
      }), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('backButton')
      })), _react.default.createElement(_UILoadingButton.default, {
        "data-test-selector": "save-edits-button",
        disabled: (0, _getIsImageEditorSaveButtonDisabled.default)({
          cropperMode: cropperMode,
          unsavedImgWidth: unsavedImgWidth,
          cropperWidth: cropperWidth,
          cropperHeight: cropperHeight
        }),
        use: "primary",
        loading: updateRequestStatus === _Constants.RequestStatus.PENDING,
        failed: updateRequestStatus === _Constants.RequestStatus.FAILED,
        onClick: function onClick() {
          if (cropperMode === 'crop') {
            if ((0, _ImageEditor.getIsCanvasToBlobSupported)()) {
              _this5.cropper.getCroppedCanvas().toBlob(function (blob) {
                onCropSave(blob, fileName, fileFolderId);
              }, "image/" + encoding);
            } else {
              (0, _ImageEditor.getCanvasBlobAndSaveFileForUnsupportedBrowsers)(_this5.cropper, fileName, encoding, fileFolderId, onCropSave);
            }
          } else {
            onResizeSave(fileId, unsavedImgWidth);
          }
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('saveButton')
      }))));
    }
  }]);
  return ImageEditor;
}(_react.Component);

ImageEditor.propTypes = {
  imgSrc: _react.PropTypes.string.isRequired,
  fileId: _react.PropTypes.number,
  fileFolderId: _react.PropTypes.number,
  fileName: _react.PropTypes.string.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  onCropSave: _react.PropTypes.func.isRequired,
  onResizeSave: _react.PropTypes.func.isRequired,
  imgHeight: _react.PropTypes.number.isRequired,
  imgWidth: _react.PropTypes.number.isRequired,
  imgAspectRatio: _react.PropTypes.number.isRequired,
  updateRequestStatus: _react.PropTypes.oneOf(Object.keys(_Constants.RequestStatus)),
  encoding: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    imgSrc: (0, _EditAndCreateImage.getImageSrc)(state),
    fileId: (0, _EditAndCreateImage.getFileToEditId)(state),
    fileFolderId: (0, _EditAndCreateImage.getFolderId)(state),
    fileName: (0, _EditAndCreateImage.getFileToEditName)(state),
    imgHeight: (0, _EditAndCreateImage.getImageHeight)(state),
    imgWidth: (0, _EditAndCreateImage.getImageWidth)(state),
    imgAspectRatio: (0, _EditAndCreateImage.getImageAspectRatio)(state),
    updateRequestStatus: (0, _EditAndCreateImage.getEditImageRequestStatus)(state),
    encoding: (0, _EditAndCreateImage.getImageEncoding)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(ImageEditor);

exports.default = _default;
module.exports = exports.default;